import { z } from 'zod';

const workflowListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  isArchived: z.boolean(),
});

export const workflowListingResponseSchema = z.object({
  items: z.array(workflowListItemSchema),
  nextPage: z.number().optional(),
});

export const entityOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const companyPartnerSchema = z.object({
  partner: z.object({
    id: z.string(),
    name: z.string(),
  }),
});

export const companyPartnersResponseSchema = z.array(companyPartnerSchema);

export const triggerDataResponseSchema = z.record(z.string(), z.array(entityOptionSchema));

export const createWorkflowResponseSchema = z.object({
  id: z.string(),
});

export type WorkflowListingResponse = z.infer<typeof workflowListingResponseSchema>;
export type TriggerDataResponse = z.infer<typeof triggerDataResponseSchema>;
export type CreateWorkflowResponse = z.infer<typeof createWorkflowResponseSchema>;
export type CompanyPartnersMappedResponse = z.infer<typeof entityOptionSchema>[];
export type CompanyPartnersResponse = z.infer<typeof companyPartnersResponseSchema>;
